var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecapIconMontant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8V7C9 4.64298 9 3.46447 9.73223 2.73223C10.4645 2 11.643 2 14 2H17C19.357 2 20.5355 2 21.2678 2.73223C22 3.46447 22 4.64298 22 7V17C22 19.357 22 20.5355 21.2678 21.2678C20.5355 22 19.357 22 17 22H14C11.643 22 10.4645 22 9.73223 21.2678C9 20.5355 9 19.357 9 17V15",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2H13.5L14 3H17L17.5 2Z",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19V19.01",
    stroke: "#5754E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 7L17.1565 7.7579C17.3357 7.934 17.4253 8.0221 17.3938 8.0969C17.3622 8.1717 17.2355 8.1717 16.9821 8.1717H13.8777C12.2884 8.1717 11 9.438 11 11C11 11.3521 11.0655 11.6891 11.185 12M13.6667 15L12.8435 14.2421C12.6643 14.066 12.5747 13.9779 12.6062 13.9031C12.6378 13.8283 12.7645 13.8283 13.0179 13.8283H16.1223C17.7116 13.8283 19 12.562 19 11C19 10.6479 18.9345 10.3109 18.815 10",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5 9 7.5 10.7998 7.5 11.5C7.5 12.2002 5 14 5 14M7 11.5L2 11.5",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapIconMontant);
export default __webpack_public_path__ + "static/media/recapIconMontant.d73a4a2525e1acb1583a7d6ae808fafc.svg";
export { ForwardRef as ReactComponent };